import { FormattedHTMLMessage } from "react-intl";

import {
  type MaxReviewTime,
  type PendingResponse,
  type VerificationService,
} from "../../lib/types/types";
import { getEstAndMaxReviewTimes } from "../../lib/utils/stepComponentHelpers/stepComponentHelpers";
import { AnnouncingHeader } from "../AnnouncingHeader/AnnouncingHeader";

interface ReviewPendingProps {
  intl: any;
  logo: JSX.Element;
  verificationService: VerificationService;
  // eslint-disable-next-line
  maxReviewTime?: MaxReviewTime; // deprecated
}

const ReviewPending = ({ intl, logo, verificationService }: ReviewPendingProps) => {
  const verificationResponse: PendingResponse =
    verificationService.verificationResponse as PendingResponse;

  const estAndMaxTimes = getEstAndMaxReviewTimes(
    { ...verificationResponse },
    verificationService.programTheme,
    intl,
  );

  return (
    <div className="sid-header sid-l-horz-center" data-testid="sid-review-pending">
      <div className="sid-l-horz-center">{logo}</div>
      <AnnouncingHeader align="center">
        <FormattedHTMLMessage
          id="step.pending.titleReview"
          defaultMessage="Reviewing"
          tagName="h1"
        />
      </AnnouncingHeader>
      <div className="sid-header__subtitle-one">
        <FormattedHTMLMessage
          id="step.pending.turnaroundTime"
          defaultMessage="Turnaround time is typically {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}."
          values={estAndMaxTimes}
        />
      </div>
      <div className="sid-header__subtitle-two sid-l-space-top-md">
        <FormattedHTMLMessage
          id="step.pending.subtitle2"
          defaultMessage="Wait here or let us notify you of the outcome."
        />
      </div>
      <div className="sid-header__subtitle-three sid-l-space-top-md">
        <FormattedHTMLMessage
          id="step.pending.subtitle3"
          defaultMessage="You will be contacted via email."
        />
      </div>
      <div className="sid-l-space-top-xl" />
    </div>
  );
};
export const ReviewPendingComponent = ReviewPending;
